import {
    DependenciesPayload,
    Subscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import {
    getSubscriptionAdditionalData,
    getSubscriptionsAll,
} from '@sxm-de/dev-kits/web-sdk/domains/subscriptions-core';

export async function getSubscriptions(
    dependencies: DependenciesPayload,
): Promise<{
    subscriptions: Subscription[];
}> {
    const { appEventSdk } = dependencies;
    try {
        const subscriptionsAll = await getSubscriptionsAll(dependencies);

        /**
         *                  === Note! ===
         * For now, we will exclude any SMS subs at this layer.
         * When we are ready to display SMS subs in the account center
         * we will need to remove this filter.
         */
        const subscriptions = subscriptionsAll.filter(
            (subscription) => !subscription.source.sms,
        );

        // Get subscription info for each subscription
        for (let i = 0; i < subscriptions.length; i++) {
            const subscription = subscriptions[i];
            const { detailedState } = await getSubscriptionAdditionalData(
                {
                    subscription,
                },
                dependencies,
            );
            subscription['detailedState'] = detailedState;
        }

        appEventSdk.trackEvent({
            event: 'customer-info',
            customerInfo: {
                subscriptions: subscriptions.map((subscription) => ({
                    id: subscription?.id,
                    planCode: subscription?.products?.[0]?.name,
                    termLength:
                        subscription?.currentPhase?.billingPeriod?.months
                            ?.count,
                    status: subscription?.state,
                    startDate: subscription?.started,
                    terminatedDate: subscription?.terminated,
                    offerId: subscription?.offerId,
                    currentPhaseType: subscription?.currentPhase?.type,
                    billingSource: Object.keys(subscription?.source)?.[0],
                })),
            },
        });
        // TODO: The existing subs logic does some "device-info" analytics tracking at this level.
        //       We should probably work with Analytics team to only have that happen when the sub
        //       is for an automotive subscription (handled in the getSubscriptionDetailedState method).

        return { subscriptions };
    } catch (error: any) {
        // TODO: handle error scenarios like 404 vs a System error
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
